export default (el: HTMLElement | null) => el && el.scrollTop;
